/**
 * Validates a value has a minimum length.
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @param {number} context.length The minimum length
 * @param {boolean} context.isTrim If set to true, it will trim the value before
 * performing the validation
 * @param {boolean} detailedError If set to true, will return an error object that
 * includes the context rather than just the error slug
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name minLength
 * @memberof combinators
 */
async function validate(value, context, detailedError = false) {
  // always pass on a null input
  if (value === undefined || value === null || value === '') {
    return Promise.resolve(null);
  }

  const isValid = (context.isTrim ? value.trim().length : value.length) <= context.length;

  if (isValid) {
    return Promise.resolve(null);
  }

  const errorSlug = 'max-length';
  if (detailedError) {
    return Promise.resolve({ errorSlug, context });
  }

  return Promise.resolve(errorSlug);
}

module.exports = validate;